import React from 'react'

// SVG
import Kuuf from 'img/snorkel_wachtlijst.inline.svg'

// Third Party
import styled from 'styled-components'
import parse from 'html-react-parser'

const StyledKuuf = styled(Kuuf)`
  position: absolute;
  top: -66px;
  left: 20px;
`

const Title = styled.div`
  padding-left: 170px;
  p {
    font-weight: ${props => props.theme.font.weight.xl};
    font-size: ${props => props.theme.font.size.ml};
    line-height: 38px;
  }
`

const StyledWorkings = styled.div`
  position: relative;

  @media screen and (max-width: 991px) {
    top: 100px;
  }
`

const Point = styled.div`
  position: relative;

  p {
    font-size: ${props => props.theme.font.size.sm};
  }

  &:before {
    content: "";
    position: absolute;
    background-color: ${props => props.theme.color.contrast};
    height: 10px;
    width: 10px;
    top: 7px;
    left: -25px;
    border-radius: 10px;
  }
`

const Points = styled.div`
  background-color: ${props => props.theme.color.beige};
  border-radius: 10px;
  padding: 30px 20px 20px 50px;
`

const Workings = ({ data, className }) => {
  return (
    <StyledWorkings className={`${className ? `${className}`: ``}`}>
      <Title className="pb-4">
        {parse(data.title)}
      </Title>
      <Points>
        <StyledKuuf />
        {data.points.map(point => (
          <Point>
            {parse(point.text)}
          </Point>
        ))}
      </Points>
    </StyledWorkings>
  )
}

export default Workings